<app-header [forceLightBackground]="true"></app-header>
<div class="consumer-support">
  <div class="flex min-h-screen w-full flex-col lg:flex-row">
    <div class="consumer-support--sidebar-col">
      <app-consumer-sidebar></app-consumer-sidebar>
    </div>
    <div class="consumer-support--content flex-1 min-w-0">
      <app-page-header></app-page-header>
      <div class="support--container">
        <app-support></app-support>
      </div>
    </div>
  </div>
</div>




